import { BillingInfoType } from '@sdk/account/api/AccountApi';
import { EXTERNAL_PAYMENT_TYPES } from '@sdk/account/constants';

type Params = {
  isManager: boolean;
  isPremium: boolean;
  isToastBilling: boolean;
  billingInfo: BillingInfoType;
};

export const getIsAddressUpdateRequired = ({
  isManager,
  isPremium,
  isToastBilling,
  billingInfo,
}: Params) => {
  const isExternalPaymentType =
    isToastBilling ||
    (billingInfo?.paymentType && billingInfo.paymentType in EXTERNAL_PAYMENT_TYPES);
  const isDuringCancellation = billingInfo?.isPremium && billingInfo.subscriptionCancelDate;

  return (
    isManager &&
    isPremium &&
    !isExternalPaymentType &&
    !isDuringCancellation &&
    billingInfo &&
    !billingInfo.isOnTrial &&
    !billingInfo.billingAddress
  );
};
